/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SquareEnvironment {
  PRODUCTION = 'production',
  SANDBOX = 'sandbox',
}
